export const SCHEDULING_LOCK_MESSAGES = {
  fapp02Started: 'The Three Years Audit Program (FAPP-02) has already been started.',
  auditDateStarted: 'The audit start date has been reached.',
};
export const parseSchedulingLockError = (error) => {
  if (error?.response?.status !== 423) return null;

  const payload = error?.response?.data || {};
  const reason = String(payload.reason || '').trim();
  return {
    locked: true,
    reason,
    message: SCHEDULING_LOCK_MESSAGES[reason]
      || String(payload.error || payload.message || 'Scheduling is locked by the server.'),
  };
};

export const getMandaysValidationErrors = (schedules = []) => {
  const errors = {};

  (Array.isArray(schedules) ? schedules : []).forEach((schedule) => {
    (Array.isArray(schedule?.mandayDetails) ? schedule.mandayDetails : []).forEach((detail) => {
      if (!String(detail?.date || '').trim()) return;
      const rawValue = String(detail?.mandays ?? '').trim();
      const numericValue = Number(rawValue);
      if (!rawValue || !Number.isFinite(numericValue) || numericValue <= 0) {
        errors[`${schedule.id}:${detail.id}`] = 'Mandays is required and must be greater than 0.';
      }
    });
  });

  return errors;
};
